window.RS = window.RS || {};
window.RS.helpers = (function() {
  const removeCartAttribute = (e) => {
    const details = e?.detail;
    const cart = details?.['cart'];
    const hasBundleAttributes = Object.keys(cart?.attributes || {}).some((key) => key.includes('_bundle_'));

    if (hasBundleAttributes) {
      const cartAttrKeys = Object.keys(cart.attributes);
      const cartItems = cart.items;
      let updatedCartAttributes = {...cart.attributes} || {};

      cartAttrKeys.forEach(key => {
        if (key.includes('_bundle_')) {
          const targetItemBundleId = key.split('_bundle_')[1];
          const isValidAttr = cartItems.find((item) => {
            const itemBundleId = item.properties?._bundle_config?.bundle_id;
            return targetItemBundleId === itemBundleId
          })

          if (!isValidAttr) {
            updatedCartAttributes[key] = null;
          }
        }
      });
      const validUpdatedCartAttributes = Object.keys(updatedCartAttributes).reduce((acc, key) => {
        if (updatedCartAttributes[key]) {
          acc[key] = updatedCartAttributes[key];
        }
        return acc;
      }, []);
      if (cartAttrKeys.length !== validUpdatedCartAttributes.length) {
        window.RS?.halo?.modifyCartAttributes(updatedCartAttributes)
      }
    }
  }

  const sumSpanValues = (selector, ...targets) => {
    const sum = Array.from(document.querySelectorAll(selector)).reduce((acc, element) => {
        const valueString = element.textContent.trim().replace('$', '');
        const value = parseFloat(valueString);

        if (!isNaN(value)) {
            return acc + value;
        } else {
            return acc;
        }
    }, 0);

    targets.forEach((target) => {
        // Totals are only rendered when the cart has items (sections/main-cart.liquid); skip missing targets
        const targetEl = document.querySelector(target);
        if (targetEl) {
            targetEl.textContent = `$${sum.toFixed(2)}`;
        }
    });

    return sum;
};

  return {
    removeCartAttribute,
    sumSpanValues
  }
})()